angular
	.module 'App.Repository'
	.factory 'CustomerDisplayMediaRepository', ['BaseRepository', (BaseRepository) ->
		class CustomerDisplayMediaRepository extends BaseRepository
			@resource = '/icd_media'
			@isRestricted = true

		return new CustomerDisplayMediaRepository
	]
